/* ====================================================================================================================
 * FAYARD CUSTOM — Réactivité (ajout au panier + menu mobile)
 * --------------------------------------------------------------------------------------------------------------------
 * 1. Ajout au panier : chargement sur le bouton, coche de validation, puis ouverture du panier latéral.
 *    On retient l'événement cart:change du thème le temps d'afficher la coche, puis on le relance.
 * 2. Menu : animations du menu latéral accélérées, sans délai au retour d'un sous-menu.
 * 3. Photos des cartes : fondu court à l'arrivée.
 * 4. Filtres et tri : grille estompée pendant le chargement.
 * 5. Mobile : vignette « À la une » escamotée pendant le défilement vers le bas.
 * 6. Couleur de la barre du navigateur (theme-color) selon le haut de l'écran.
 * Chargé depuis layout/theme.liquid. Aucune modification de theme.js.
 * ==================================================================================================================== */
(function () {
  var CHECK_MS = 600;
  var pending = null;

  function clear(btn) {
    if (!btn) return;
    btn.classList.remove('fy-atc-loading', 'fy-atc-done');
  }

  /* 1. Ajout au panier
   * ---------------------------------------------------------------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !form.closest('product-form')) return;
    if (form.closest('quick-buy-modal')) return;
    if (!form.checkValidity()) return;

    var btn = event.submitter && event.submitter.type === 'submit' ? event.submitter : form.querySelector('button[type="submit"]');
    if (!btn || btn.classList.contains('fy-atc-loading')) return;

    start(btn);
  }, true);

  function start(btn) {
    if (pending && pending.btn === btn) return;
    if (pending) { clearTimeout(pending.timer); clear(pending.btn); }
    btn.classList.add('fy-atc-loading');
    pending = { btn: btn, timer: setTimeout(function () { clear(btn); pending = null; }, 10000) };
  }

  function fail() {
    if (!pending) return;
    clearTimeout(pending.timer);
    clear(pending.btn);
    pending = null;
  }

  // Pour les ajouts faits hors du formulaire du thème (coffret dont un goût a changé : snippets/coffret-gout.liquid)
  window.fyAtc = { start: start, fail: fail };

  document.documentElement.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    if (detail.baseEvent !== 'variant:add' || detail.fyReleased || !pending) return;

    var btn = pending.btn;
    clearTimeout(pending.timer);
    pending = null;
    if (!document.contains(btn)) return;

    event.stopImmediatePropagation();
    btn.classList.remove('fy-atc-loading');
    btn.classList.add('fy-atc-done');

    setTimeout(function () {
      var released = Object.assign({}, detail, { fyReleased: true });
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: released }));
      setTimeout(function () { clear(btn); }, 700);
    }, CHECK_MS);
  }, true);

  document.addEventListener('cart:error', fail);

  /* 2. Menu latéral plus rapide
   * On remplace les animations du thème (0,3 s + apparition des liens un à un) par des animations courtes.
   * ---------------------------------------------------------------------------------------------------------------- */
  var EASE = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
  var OPEN_MS = 180;
  var PANEL_MS = 120;

  function run(list) {
    var anims = [];
    list.forEach(function (item) {
      var targets = item[0] && item[0].length !== undefined && !item[0].animate ? Array.prototype.slice.call(item[0]) : [item[0]];
      targets.forEach(function (el) {
        if (!el || !el.animate) return;
        var a = el.animate(item[1], { duration: item[2], easing: EASE, fill: 'forwards' });
        a.finished.then(function () { try { a.commitStyles(); } catch (e) {} a.cancel(); }, function () {});
        anims.push(a);
      });
    });
    return {
      finished: Promise.all(anims.map(function (a) { return a.finished.catch(function () {}); })).then(function () {}),
      finish: function () { anims.forEach(function (a) { try { a.finish(); } catch (e) {} }); },
      cancel: function () { anims.forEach(function (a) { a.cancel(); }); },
      stop: function () { anims.forEach(function (a) { a.cancel(); }); }
    };
  }

  customElements.whenDefined('header-sidebar').then(function () {
    var proto = customElements.get('header-sidebar').prototype;
    if (proto.fyFast) return;
    proto.fyFast = true;

    proto.createEnterAnimationControls = function () {
      var fromRight = this.openFrom === 'right';
      var content = this.getShadowPartByName('content');
      content.style.marginInlineStart = fromRight ? 'auto' : 0;
      return run([
        [this.getShadowPartByName('overlay'), { opacity: [0, 1] }, OPEN_MS],
        [content, { transform: ['translateX(' + (fromRight ? '100%' : '-100%') + ')', 'translateX(0)'] }, OPEN_MS]
      ]);
    };

    proto.createLeaveAnimationControls = function () {
      var fromRight = this.openFrom === 'right';
      return run([
        [this.getShadowPartByName('overlay'), { opacity: [1, 0] }, OPEN_MS],
        [this.getShadowPartByName('content'), { transform: ['translateX(0)', 'translateX(' + (fromRight ? '100%' : '-100%') + ')'] }, OPEN_MS]
      ]);
    };

    proto.revealItems = function () {
      var main = this.querySelector('.header-sidebar__main-panel');
      if (main) { main.style.opacity = '1'; main.style.transform = 'translateX(0)'; }
      return run([
        [this.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist li'), { opacity: [0, 1] }, PANEL_MS],
        [this.querySelector('.header-sidebar__footer'), { opacity: [0, 1] }, PANEL_MS]
      ]);
    };
  });

  customElements.whenDefined('header-sidebar-collapsible-panel').then(function () {
    var proto = customElements.get('header-sidebar-collapsible-panel').prototype;
    if (proto.fyFast) return;
    proto.fyFast = true;
    var mobile = window.matchMedia('screen and (max-width: 999px)');
    var enter = proto.createEnterAnimationControls;
    var leave = proto.createLeaveAnimationControls;

    proto.createEnterAnimationControls = function () {
      if (!mobile.matches) return enter.apply(this, arguments);
      return run([[this, { opacity: [0, 1], transform: ['translateX(0)', 'translateX(0)'] }, PANEL_MS]]);
    };

    proto.createLeaveAnimationControls = function () {
      if (!mobile.matches) return leave.apply(this, arguments);
      return run([[this, { opacity: [1, 0] }, PANEL_MS]]);
    };
  });

  /* 3. Photos des cartes : fondu court à l'arrivée au lieu d'une apparition brutale
   * ---------------------------------------------------------------------------------------------------------------- */
  var FADE_SCOPE = 'product-card, .product-card, product-gallery, .coffret-content__media, .collection-card, .fe-card, .gc-card';

  function prepImage(img) {
    if (img.dataset.fyFade || !img.closest(FADE_SCOPE)) return;
    img.dataset.fyFade = '1';
    if (img.complete && img.naturalWidth > 0) return;

    img.classList.add('fy-img-wait');
    var done = function () {
      img.classList.add('fy-img-fading');
      img.classList.remove('fy-img-wait');
      setTimeout(function () { img.classList.remove('fy-img-fading'); }, 350);
    };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function prepImages(root) {
    if (root.tagName === 'IMG') prepImage(root);
    else if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('img'), prepImage);
  }

  // Barre de livraison offerte : le thème écrit le montant restant à la mode du navigateur (« 113,01 $CA ») ;
  // on le remet au format des prix du site ($113.01).
  var SPACE = '[\\s\\u00a0\\u202f]';
  var LOCAL_MONEY = new RegExp('(\\d{1,3}(?:' + SPACE + '\\d{3})*),(\\d{2})' + SPACE + '*\\$(?:' + SPACE + '?CA)?', 'g');

  function fixShippingMoney(bar) {
    var walker = document.createTreeWalker(bar, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue;
      var fixed = text.replace(LOCAL_MONEY, function (match, whole, cents) {
        return '$' + whole.replace(new RegExp(SPACE, 'g'), ',') + '.' + cents;
      });
      if (fixed !== text) node.nodeValue = fixed;
    }
  }

  prepImages(document);
  Array.prototype.forEach.call(document.querySelectorAll('free-shipping-bar'), fixShippingMoney);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, function (node) {
        prepImages(node);
        if (node.querySelectorAll) Array.prototype.forEach.call(node.querySelectorAll('free-shipping-bar'), fixShippingMoney);
      });
      var target = record.target.nodeType === 3 ? record.target.parentElement : record.target;
      var bar = target && target.closest && target.closest('free-shipping-bar');
      if (bar) fixShippingMoney(bar);
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  /* 4. Filtres et tri des collections : la grille s'estompe pendant le chargement
   * ---------------------------------------------------------------------------------------------------------------- */
  var BUSY_SCOPE = 'main product-list, main .collection__results, main .main-search__results';
  var busyTimer = null;

  function clearBusy() {
    clearTimeout(busyTimer);
    Array.prototype.forEach.call(document.querySelectorAll('.fy-busy'), function (el) { el.classList.remove('fy-busy'); });
  }

  document.addEventListener('facet:update', function () {
    Array.prototype.forEach.call(document.querySelectorAll(BUSY_SCOPE), function (el) { el.classList.add('fy-busy'); });
    clearTimeout(busyTimer);
    busyTimer = setTimeout(clearBusy, 8000);
  });

  document.documentElement.addEventListener('theme:loading:end', clearBusy);

  /* 5. Mobile : la vignette « À la une » s'efface quand on descend, revient quand on remonte
   * ---------------------------------------------------------------------------------------------------------------- */
  var phone = window.matchMedia('screen and (max-width: 699px)');
  var lastY = window.scrollY;
  var ticking = false;

  function onScroll() {
    ticking = false;
    var stories = document.querySelector('fayard-stories');
    var y = window.scrollY;
    var delta = y - lastY;
    if (!stories || !phone.matches) { lastY = y; return; }

    if (y < 160 || delta < -8) stories.classList.remove('is-tucked');
    else if (delta > 8) stories.classList.add('is-tucked');

    if (Math.abs(delta) > 8 || y < 160) lastY = y;
  }

  /* 6. Couleur de la barre du navigateur selon ce qui est en haut de l'écran (Chrome Android surtout ;
   *    Safari récent prend la couleur de l'en-tête collant de lui-même)
   * ---------------------------------------------------------------------------------------------------------------- */
  var themeMeta = document.querySelector('meta[data-fy-theme-color]');
  if (themeMeta && themeMeta.parentNode !== document.head) document.head.appendChild(themeMeta);
  var COLOR_TOP = '#d01674';
  var COLOR_HEADER = '#1c1c1c';
  var COLOR_PAGE = '#fafaf9';

  function paintBar() {
    if (!themeMeta) return;
    var header = document.querySelector('x-header');
    var bar = document.querySelector('.shopify-section--announcement-bar');
    var barHeight = bar ? bar.getBoundingClientRect().bottom : 0;
    var color = COLOR_HEADER;
    if (barHeight > 4) color = COLOR_TOP;
    else if (header && header.classList.contains('is-hidden')) color = COLOR_PAGE;
    if (themeMeta.getAttribute('content') !== color) themeMeta.setAttribute('content', color);
  }

  paintBar();
  var xHeader = document.querySelector('x-header');
  if (xHeader) new MutationObserver(paintBar).observe(xHeader, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); paintBar(); }); }
  }, { passive: true });
})();
